import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidationUtilityService {

  constructor() { }

  /**
   * Validates a keyboard input event against a specified regular expression pattern.
   *
   * Prevents the default action if the input character does not match the allowed pattern.
   *
   * @param event - The keyboard event triggered by user input.
   * @param allowedPattern - The regular expression pattern to test the input character against. Defaults to allowing alphanumeric characters, plus, minus, at symbol, and space.
   * @returns `true` if the input character is allowed; otherwise, `false`.
   */
  validateInput(event: KeyboardEvent, allowedPattern: any= /^[a-zA-Z0-9.+\-@ ]$/): boolean {
    const inputChar = event.key;
    if (!allowedPattern.test(inputChar)) {
      event.preventDefault();
      return false;
    }
    return true;
  }
}
